export const RANDOM = 'RANDOM';
export const MOST_RECENT = 'MOST_RECENT';
export const MOST_POPULAR = 'MOST_POPULAR';
